import UnmatchedAcceptance from './unmatched_acceptance.vue';

export default UnmatchedAcceptance;
